<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uyly7/tc-custom/9781439677940.jpg?1738411515727" alt="This image is the cover for the book Ghostly Tales of Southern California"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostly Tales of Southern California
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from Southern California have never been so creepy, fun, and full of mystery! <br/> Welcome to spooky Southern California!       Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. <br/> Did you know the Hollywood Forever Cemetery is home to ghostly movie stars? Or that some ghosts get to spend eternity at Disneyland, "The Happiest Place on Earth?" Can you believe spirits from all over have turned Silver City into a  literal Ghost Town? <br/> Pulled right from history, these ghostly tales will change the way you see Southern California, and have you sleeping with the light on!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Alleva
      </h2>
      
      <p class="authorDescription body article">Dan Alleva is an author, editor, and journalist from Brooklyn, New York. You can read his daily news stories from the world of music online at  Metal Injection , and find some of his truly hilarious  Mad Libs  titles in your favorite local bookstore. When not writing, Dan can be found rooting on his beloved Manchester United, or at the beach with his wife and daughter, and their sweet little doggie, Georgia. You can learn more at  www.danalleva.com .</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?682b8f04